import React from 'react';
import { Controller } from 'react-hook-form';
import { FormInputDate } from '../../../common/formInputsV2/FormInputDate';
import CauzioniPriceInput from '../CauzioniPriceInput';
import { FormInputTextarea } from '../../../common/formInputsV2/FormInputTextarea';
import InputByType from '../../Commercial/components/parts/InputByTypeV2';
import { getCauzioniFormFields } from '../formFields';
import { DOCUMENT_HINT } from '../documentPrefill';

/* Descriptors are flat; a descriptor's own `reveals` array names other descriptors that
   should stay hidden until it holds a truthy value. Build a reverse map once so rendering
   just checks "am I revealed by someone, and is that someone truthy". */
const buildRevealedByMap = (descriptors) => {
  const map = {};
  descriptors.forEach((descriptor) => {
    (descriptor.reveals || []).forEach((name) => { map[name] = descriptor.name; });
  });
  return map;
};

function StepGaranzia({
  register, errors, watch, setValue, isValid, control, subProduct,
  prefilled = new Set(),
}) {
  const formFields = getCauzioniFormFields(subProduct?.slug);
  const revealedBy = buildRevealedByMap(formFields);
  const extraData = watch('extra_data') || {};

  const visibleFields = formFields.filter((descriptor) => {
    const revealerName = revealedBy[descriptor.name];
    if (!revealerName) return true;
    return Boolean(extraData[revealerName]);
  });

  return (
    <div data-testid="cauzioni-step-garanzia">
      <div className="cauzioni-info-card">
        <div className="cauzioni-card-body">
          <h2 className="cauzioni-card-title mb-3">Dati della garanzia</h2>

          <FormInputDate
            label="Data di effetto"
            registration={register('effective_date')}
            error={errors.effective_date?.message}
            valid={isValid('effective_date')}
            hint={prefilled.has('effective_date') ? DOCUMENT_HINT : undefined}
          />
          <FormInputDate
            label="Data di scadenza"
            registration={register('expiry_date')}
            error={errors.expiry_date?.message}
            valid={isValid('expiry_date')}
            hint={prefilled.has('expiry_date') ? DOCUMENT_HINT : undefined}
          />
          <Controller
            name="guaranteed_amount"
            control={control}
            render={({ field: { value, onChange, onBlur } }) => (
              <CauzioniPriceInput
                name="guaranteed_amount"
                label="Somma garantita"
                value={String(value || '')}
                onChange={onChange}
                onBlur={onBlur}
                error={errors.guaranteed_amount?.message}
                valid={isValid('guaranteed_amount')}
                hint={prefilled.has('guaranteed_amount') ? DOCUMENT_HINT : undefined}
              />
            )}
          />
          <FormInputTextarea
            label="Descrizione"
            registration={register('description')}
            error={errors.description?.message}
            valid={isValid('description') && Boolean(watch('description'))}
            hint={prefilled.has('description') ? DOCUMENT_HINT : undefined}
          />
          <FormInputTextarea
            label="Note"
            registration={register('notes')}
            error={errors.notes?.message}
            valid={isValid('notes') && Boolean(watch('notes'))}
          />
        </div>
      </div>

      {formFields.length > 0 && (
        <div className="cauzioni-info-card">
          <div className="cauzioni-card-body">
            <h2 className="cauzioni-card-title mb-3">Ulteriori informazioni</h2>
            {visibleFields.map((descriptor) => (
              <InputByType
                key={descriptor.name}
                input={{ ...descriptor, name: `extra_data.${descriptor.name}` }}
                register={register}
                errors={errors}
                isValid={isValid}
                setValue={setValue}
                control={control}
                watch={watch}
                formData={watch()}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default StepGaranzia;
